module.exports = require("winston");


/*****************
 ** WEBPACK FOOTER
 ** external "winston"
 ** module id = 16
 ** module chunks = 0
 **/